import useLoanEntities from '../../../hooks/useLoanEntities'
import { CATEGORY_LABELS, PHASE_LABELS, BorrowerType } from '../../../constants'
import { shouldPreventManualFileCreation } from '../../../utils'

const createSection = ({ entity, document }) =>
  entity.borrowerType === BorrowerType.oc
    ? CATEGORY_LABELS[document.category]
    : PHASE_LABELS[document.phase]

function useTargetDocumentBucketOptions({ originDocumentId }) {
  const entities = useLoanEntities()
  const targetOptions = []

  entities.forEach((entity) =>
    targetOptions.push(
      ...entity.documents
        .filter((document) => !shouldPreventManualFileCreation(document))
        .filter((document) => document.rid !== originDocumentId)
        .map((document) => ({
          entityName: entity.name,
          entityType: entity.__typename,
          documentId: document.rid,
          documentCategory: document.category,
          DocumentPhase: document.phase,
          documentTitle: document.title,
          id: document.rid,
          section: createSection({ entity, document }),
        }))
    )
  )

  return targetOptions
}

export default useTargetDocumentBucketOptions
